(function () {
  class ExtraLifeAnimsView extends PIXI.Container {
    constructor() {
      super();
    }

    initialise() {
      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this.heartOn = resourceManager.get("extraLifeAnimsView:heartOn");
      this.heartOff = resourceManager.get("extraLifeAnimsView:heartOff");
      this.heartOn.visible = false;
      this.heartOff.visible = false;

      this.heart = resourceManager.get("extraLifeAnimsView:extraLifeHeart");
      this.heart.visible = false;
      this.heart.gotoAndStop(0);

      this.extraLifeTextContainer = resourceManager.get(
        "extraLifeAnimsView:textContainer"
      );

      this.extraLifeText = resourceManager.get(
        "extraLifeAnimsView:textContainer:extraLifeText"
      );
      this.extraLifeText.visible = false;

      this.burstAnim = resourceManager.get("extraLifeAnimsView:burstAnim");
      this.burstAnim.gotoAndStop(0);

      this.createTweens();

      messageBus.subscribe(
        "ExtraLife:showAnimation",
        this.showHeart.bind(this)
      );
      messageBus.subscribe(
        "ExtraLife:hideAnimation",
        this.hideHeart.bind(this)
      );
      messageBus.subscribe("ExtraLife:reset", this.resetHeart.bind(this));
    }

    createTweens() {
      this.heartOnTween = gsap.fromTo(
        this.heartOn,
        {
          alpha: 0,
        },
        {
          duration: 0.5,
          alpha: 1,
          paused: true,
          loop: true,
          repeat: -1,
          onStart: () => {
            this.heartOn.visible = true;
            this.heartOff.visible = true;
          },
        }
      );
    }

    setLifeText() {
      if (gameController.totalExtraLives > 1) {
        this.extraLifeText.setText(gameController.totalExtraLives);
        this.extraLifeText.visible = true;
      } else {
        this.extraLifeText.visible = false;
      }
    }

    showHeart() {
      this.heart.visible = true;
      this.heart.scale.x = 1;
      this.heart.scale.y = 1;

      const self = this;

      self.heartOn.visible = false;
      self.heartOff.visible = false;
      self.extraLifeText.visible = false;

      gameController.totalExtraLives++;

      this.burstAnim.gotoAndPlay(0);

      this.heart.onComplete = function () {
        self.heartOnTween.restart(true).time(0);

        self.heartOn.visible = true;
        self.heartOff.visible = true;

        self.setLifeText();
      };

      this.heart.gotoAndPlay(0);

      this.heartPulseTween = gsap.fromTo(
        [
          this.heartOn.scale,
          this.heartOff.scale,
          this.extraLifeTextContainer.scale,
        ],
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.2,
          y: 1.2,
          duration: 0.5,
          paused: true,
          loop: true,
          repeat: -1,
          yoyo: true,
        }
      );
      this.heartPulseTween.restart(true).time(0);
    }

    hideHeart() {
      const self = this;

      self.heartOn.visible = false;
      self.heartOff.visible = false;
      self.heart.visible = true;

      gameController.totalExtraLives--;

      gameController.extraLifeUsed = true;

      self.setLifeText();

      this.burstAnim.gotoAndPlay(0);

      if (gameController.totalExtraLives === 0) {
        gsap.to(self.heart.scale, {
          duration: 0.2,
          delay: 0.2,
          x: 0,
          y: 0,
        });
      }

      self.heart.gotoAndPlay(0);
      self.heart.onComplete = function () {
        if (gameController.totalExtraLives === 0) {
          self.heartPulseTween.restart(false).time(0);
          self.heartOn.visible = false;
          self.heartOff.visible = false;
          self.heart.visible = false;
          self.heart.gotoAndStop(0);
          self.heartOnTween.pause();
        } else {
          self.heart.gotoAndStop(0);
          self.heartOn.visible = true;
          self.heartOff.visible = true;
          self.heart.visible = false;
          self.heartOnTween.restart(true).time(0);
        }
      };
    }

    resetHeart() {
      this.heartOn.visible = false;
      this.heartOff.visible = false;
      this.heart.visible = false;
      this.extraLifeText.visible = false;
    }

    getSourcePos() {
      return this._sourcePos;
    }
  }

  create = function (json) {
    return new ExtraLifeAnimsView();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType(
    "extraLifeAnimsView",
    create,
    initialise,
    getFilesRequired
  );
})();
